<template>
  <div>
    Suivi des parcours
  </div>
</template>

<script>
export default {
  name: 'TrackingRoutes'
};
</script>
